<template>
	<information-card
		:title="title"
		:sub-title="subtitle"
	>
		<div slot="content">
			<slot name="content" />
		</div>
	</information-card>
</template>

<script>
import InformationCard from '@/modules/shared/components/content/InformationCard';

export default {
	name: 'model-description',
	components: {
		InformationCard,
	},
	props: {
		title: String,
		subtitle: String,
	},
};

</script>

<style lang="scss" scoped>
.textjustify {
	text-align: center;
	font-size: 12px;
}
.content-rule {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border: 1px solid map-get($colors, gray-slider);
	background-color: #F9F9F9;
	border-radius: 4px;
	font-size: 10px;
	height: 100%;
}
.text-color {
	color: #f09c2e;
	padding-left: 5px;
}
.table-info {
	border: #f09c2e 1px solid;
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.row-table-info {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	
}
.btn-model {
	background-color: #F9F9F9;
	width: 50px;
	height: 25px;
	border-radius: 8px;

}
.content-table {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	tr {
		margin: 10px 0;
	}
	h2, td {
		font-size: 13px;
		font-weight: bold;
		text-align: left;
		padding-left: 15px;
	}
	button {
		border-radius: 4px;
		border: none;
		width: 45px;
		height: 20px;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/job-profile/components/content/model-description.vue